const rankingData = [
  {
    rank: 1,
    title: '樱花树下的约定',
    type: '校园恋爱',
    hot: '本周最热',
    desc: '高中最后一年的樱花季节，羞涩少女与邻桌少年之间青涩又甜蜜的恋爱故事，蜜桃动漫在线校园系列人气榜首。',
  },
  {
    rank: 2,
    title: '异世界召唤师',
    type: '奇幻冒险',
    hot: '新番热榜',
    desc: '普通女高中生被召唤到魔法世界，凭借智慧与勇气踏上冒险之旅，羞羞动漫在线新番热度飙升最快作品。',
  },
  {
    rank: 3,
    title: '蜜桃少女日记',
    type: '恋爱甜宠',
    hot: '热议中',
    desc: '三位性格迥异的蜜桃少女在都市中的恋爱与成长故事，羞羞动漫在线观看完整版累计播放量突破百万。',
  },
  {
    rank: 4,
    title: '星之彼端',
    type: '奇幻冒险',
    hot: '新番上线',
    desc: '未来科幻与蜜桃恋爱交织的震撼新作，羞羞动漫在线新番版块48小时同步上线，画面精美剧情紧凑。',
  },
  {
    rank: 5,
    title: '夏日柠檬草',
    type: '治愈温情',
    hot: '口碑佳作',
    desc: '海风、柠檬草与青春，一部让人心醉的治愈系蜜桃动漫在线作品，羞羞动漫在线高清播放画质惊艳。',
  },
  {
    rank: 6,
    title: '夜莺与蔷薇',
    type: '百合蜜桃',
    hot: '热度攀升',
    desc: '古典欧洲背景下的百合蜜桃故事，精致画风与细腻情感并重，蜜桃动漫在线百合系列评分最高作品。',
  },
];

const rankColors = ['bg-accent-500', 'bg-accent-400', 'bg-accent-300', 'bg-secondary-400', 'bg-secondary-400', 'bg-secondary-400'];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            热度榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            蜜桃动漫在线本周最受欢迎作品排行
          </p>
        </div>

        <div className="max-w-[900px] mx-auto space-y-3">
          {rankingData.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 bg-background-100/60 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div
                className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl ${rankColors[i]} text-background-50 font-heading text-lg font-bold`}
              >
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="font-heading text-base font-semibold text-foreground-800">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-400 bg-background-200/70 px-2 py-0.5 rounded-full">
                    {item.type}
                  </span>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed truncate">
                  {item.desc}
                </p>
              </div>
              <span className="flex-shrink-0 text-xs font-semibold text-accent-600 bg-accent-50 px-3 py-1 rounded-full whitespace-nowrap">
                {item.hot}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}